// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_P600l","inner":"style_inner_3ICgH"};